const Button2 = ({ value }) => {
  return (
    <div className="font-hk text-center bg-opacity-90 py-3 transition-all hover:scale-[1.05] shadow-black hover:shadow-lg text-[12px] md:text-[13px] xl:text-sm font-medium text-white bg-black border-[1px] rounded-2xl lg:rounded-full h-[45px] w-[90px] md:w-[105px] xl:w-[130px]">
      {value}
    </div>
  );
};

export default Button2;
